// 1m / 5m / 15m loadavg triple. Mirrors htop's bottom-of-header readout.
//
// The 1m number gets the LoadIndicator color treatment so the operator can
// scan a fleet table and immediately see hot boxes; 5m / 15m stay neutral
// (they're context, not the alert signal).

import { cn } from "@veil/ui/lib/utils";

interface Props {
	loadAvg1m?: number | null;
	loadAvg5m?: number | null;
	loadAvg15m?: number | null;
	className?: string;
}

function classify(load: number): string {
	if (load < 1) return "text-emerald-600";
	if (load < 4) return "text-amber-600";
	return "text-destructive";
}

function formatLoad(v: number | null | undefined): string {
	if (typeof v !== "number" || Number.isNaN(v)) return "—";
	return v.toFixed(2);
}

export function LoadReadout({
	loadAvg1m,
	loadAvg5m,
	loadAvg15m,
	className,
}: Props) {
	const oneColor =
		typeof loadAvg1m === "number"
			? classify(loadAvg1m)
			: "text-muted-foreground";

	return (
		<div className={cn("flex flex-col gap-1", className)}>
			<span className="text-[10px] uppercase text-muted-foreground">
				Load avg
			</span>
			<div className="flex items-baseline gap-3 font-mono tabular-nums">
				<span className={cn("text-lg font-semibold", oneColor)}>
					{formatLoad(loadAvg1m)}
				</span>
				<span className="text-xs text-muted-foreground">
					{formatLoad(loadAvg5m)}
				</span>
				<span className="text-xs text-muted-foreground">
					{formatLoad(loadAvg15m)}
				</span>
			</div>
			<span className="text-[10px] uppercase tracking-wider text-muted-foreground">
				1m · 5m · 15m
			</span>
		</div>
	);
}
